//--general
import {categories} from './parts/categories.js';
import {trainings} from './parts/trainings.js';
import {experts, expertsList, loadMoreExperts} from './parts/experts.js';
import {opinions} from './parts/opinions.js';
import {news} from './parts/news.js';
import {customers} from './parts/customers.js';
import {media} from './parts/media.js';
import {text_cut} from './parts/text_cut.js';
import {addUser, processApply, importUserData} from './parts/apply_form.js';
import {search_engine} from './parts/search_engine.js';
import {mapLocations} from './parts/locations.js';
import {cookies} from './parts/cookies.js';
//import {Util} from './plugins/bootstrap/util.js';
//import {ScrollSpy} from './plugins/bootstrap/scrollspy.js';


(function ($) {
    
    //-- delay function for resizing
    var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();
    
    function fixedTraining(){
        if ($('.fixed-box').length > 0){
            if ($(window).width() > 1199) {
                if ($('.fixed-box').attr('style') == undefined) {
                    $('.fixed-box').scrollToFixed( {
                        marginTop: 10,
                        limit: $('.box-limit').offset().top - $('.training-item').height() - 40,
                    });

                } else {
                    $('.fixed-box').trigger('detach.ScrollToFixed')
                }

            } else {
                if ($('.fixed-box').attr('style') !== undefined) {
                    $('.fixed-box').trigger('detach.ScrollToFixed')
                }
            }
        }
    }
    
    function fixedSubNav(){
        if ($('#subnav').length > 0){
            if ($(window).width() > 992) {
                if ($('#subnav').attr('style') == undefined) {
                    $('#subnav').scrollToFixed();

                } else {
                    $('#subnav').trigger('detach.ScrollToFixed')
                }

            } else {
                if ($('#subnav').attr('style') !== undefined) {
                    $('#subnav').trigger('detach.ScrollToFixed')
                }
            }
        }
    }

    $(document).ready(function(){

        cookies();

        objectFitImages();

        categories()
        trainings()
        experts()
        loadMoreExperts()
        opinions()
        news()
        customers()
        media()
        text_cut()
        search_engine()
        
        mapLocations()

        $('.training-item').not('.training--apply').find('h3').shave(65);
        
        fixedTraining()
        
        fixedSubNav()
        
        addUser()

        processApply()

        importUserData()
        
        expertsList()
        
        //closed trainig - load more refs
        var load_more_refs = $('#load-more-refs');
        if( $('.refs-item').not('.active').length == 0 ){
            load_more_refs.hide();
        }

        load_more_refs.on('click', function(e){
            e.preventDefault();

            var refs = refs = $('#refs'),
                all_refs = refs.find('.refs-item'),
                hidden_refs = refs.find('.refs-item').not('.active'),
                toshow = 4;

                hidden_refs.prev().nextAll(':lt('+toshow+')').addClass('active');

                if( hidden_refs.length - toshow <= 0 ){
                    load_more_refs.hide();
                }

        });


        //load more articles
        var load_more_arts = $('#load-more-articles'),
            list = $('#articles'),
            offset = list.find('.article-item').length;
            
        load_more_arts.on('click', function(e){
            e.preventDefault();

            var category = $(this).attr('data-category');

            $.ajax({
                url: "/ajax/get-articles",
                type: 'POST',
                data: {
                    offset: offset,
                    category: category
                },
                dataType: "json",
                success: function (data) { 

                    offset=offset+data.length;

                    if( data.length === 0 ){
                        load_more_arts.hide();
                    }
    
                    $.each( data, function( key ) {
    
                        var title = data[key].title,
                            content = data[key].content,
                            cover = data[key].cover,
                            route = data[key].route,
                            date = data[key].date.date;
                            
                            var date    = new Date(date),
                                yr      = date.getFullYear(),
                                month   = date.getMonth() < 10 ? '0' + date.getMonth()+1 : date.getMonth()+1,
                                day     = date.getDate()  < 10 ? '0' + date.getDate()  : date.getDate(),
                                newDate = day + '/' + month + '/' + yr;
                        
                        list.append('<div class="col-lg-12"><div class="item news-item news-item--horizontal news-item--article"><a href="'+route+'"><div class="img-box"><img src="'+cover+'" alt="'+title+'"></div><div class="content"><div class="date">'+newDate+'</div><div class="desc">'+title+'</div><div class="txt">'+content+'</div><span class="morelink read-more"><span>Czytaj więcej</span><i class="icon-arrow"></i></span></div></a></div></div>');
                        
                    });
    
                },
                error: function (error) { console.log('error'); }
            });
        });
        
        
        // read more "szkolenia lista"
        var showChar = 130;  // How many characters are shown by default
        var ellipsestext = "...";
        var moretext = "<span class='expand show-btn'><img src='/assets/img/svg/arrow-down-green.svg' alt=''></span>";
        var lesstext = "<span class='shrink show-btn'><img src='/assets/img/svg/arrow-down-green.svg' alt=''></span>";


        $('.search_engine_note').each(function() {
            var content = $(this).html();
            var indexCut = content.indexOf('</p>')
            
            if (indexCut > 0) {
                showChar = indexCut + 4;
            }

            if(content.length > showChar) {

                var c = content.substr(0, showChar);
                var h = content.substr(showChar, content.length - showChar);

                var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

                $(this).html(html);
            }

        });

        $(".morelink").click(function(){
            if(!$(this).hasClass("post")) {
                if($(this).hasClass("less")) {
                    $(this).removeClass("less");
                    $(this).html(moretext);
                } else {
                    $(this).addClass("less");
                    $(this).html(lesstext);
                }
                $(this).parent().prev().toggle();
                $(this).prev().toggle();
                return false;
            }
        });
        
        $("#nav-btn").parents('.nav-bar').click(function(){
            $(this).toggleClass('opened')
        })
                
        $('.categories-banner-mobile').on('change', function () {
          var url = $(this).val();
          if (url) {
              window.location = url;
          }
          return false;
      });
        
        /*
        * Replace all SVG images with inline SVG
        */
       $('img.svg').each(function(){
           var $img = $(this);
           var imgID = $img.attr('id');
           var imgClass = $img.attr('class');
           var imgURL = $img.attr('src');

           $.get(imgURL, function(data) {
               // Get the SVG tag, ignore the rest
               var $svg = $(data).find('svg');

               // Add replaced image's ID to the new SVG
               if(typeof imgID !== 'undefined') {
                   $svg = $svg.attr('id', imgID);
               }
               // Add replaced image's classes to the new SVG
               if(typeof imgClass !== 'undefined') {
                   $svg = $svg.attr('class', imgClass+' replaced-svg');
               }

               // Remove any invalid XML tags as per http://validator.w3.org
               $svg = $svg.removeAttr('xmlns:a');

               // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
               if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                   $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
               }

               // Replace image with new SVG
               $img.replaceWith($svg);

           }, 'xml');

       });

    });

    $(window).resize(function(){
        categories()
        trainings()
        experts()
        opinions()
        news()
        customers()
        media()
        fixedTraining()
        fixedSubNav()
    })
    

    $(window).on({
        load:function(){
            //animations
            
            if($('body').hasClass('page--home')) {
            
                AOS.init({
                    duration: 700,
                    disable: 'mobile'
                });
                
            }
            
        },
        resize:function(){


        },
        scroll:function(){

       }
    });
    

}(jQuery));